import { getSuggestionsService } from './getSuggestionsService';
import postProcessSuggestionsResult from './postProcessSuggestionsResult';
import processResponseResults from './processResponseResults';
import { populateFeedbackStateNetwork } from '../../utils/populateFeedbackState';
import setIsSearching from '../setIsSearching';
import updateCurrentRenderedQueryString from '../updateCurrentRenderedQueryString';
import getTransactionIdFromResponse from '../../utils/getTransactionIdFromResponse';
import { now } from 'owa-datetime';
import { FindResultType } from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import addTransactionComplete from 'owa-recipient-common/lib/utils/addTransactionComplete';
import { action } from 'satcheljs/lib/legacy';
import FindControlViewState, {
    DirectorySearchType,
} from 'owa-recipient-common/lib/store/schema/FindControlViewState';

const MAX_ENTRIES_DIRECTORY = 20;

export default action('autoSearchDirectory')(async function autoSearchDirectory(
    recipientWell: FindControlViewState,
    recipients: ReadWriteRecipientViewState[],
    queryString: string,
    resolveIfSingle?: boolean
): Promise<void> {
    let suggestionService = getSuggestionsService();
    let transactionStartTime = now();
    // Record the beginning of the live call
    // in case the live call hangs and the user submits feedback before it returns
    populateFeedbackStateNetwork(
        recipientWell,
        transactionStartTime,
        null /*response*/,
        true /*directory*/
    );
    let response = await suggestionService(
        queryString,
        true /* searchDirectory*/,
        recipientWell.findPeopleFeedbackManager
    );
    setIsSearching(recipientWell, false);
    let sameQueryString = recipientWell.queryString.trim() == queryString;

    if (sameQueryString) {
        let maxFindResultShown = MAX_ENTRIES_DIRECTORY;
        updateCurrentRenderedQueryString(recipientWell, queryString);
        processResponseResults(
            recipientWell.findResultSet,
            response,
            false /*appendResults*/,
            maxFindResultShown,
            true /*returnMaskedRecipients*/
        );

        populateFeedbackStateNetwork(
            recipientWell,
            transactionStartTime,
            response,
            true /*directory*/
        );
        addTransactionComplete(
            recipientWell,
            transactionStartTime,
            getTransactionIdFromResponse(response)
        );
        recipientWell.directorySearchType = DirectorySearchType.Auto;
        /* manually trigger rerender if the response has 0 elements */
        if (recipientWell.findResultSet.length == 0) {
            recipientWell.findResultSet = [];
        }
        postProcessSuggestionsResult(
            recipientWell,
            recipients,
            FindResultType.SearchDirectory,
            resolveIfSingle
        );
    }
});
